/**
 * Auto-generated from dark-roast enum types — string-literal union types
 * derived from the Java backend's wire enum values. Do not edit manually.
 * Regenerate with: yarn sync-entities
 */

export enum EmploymentStatus {
  Active = "Active",
  Beach = "Beach",
  FormerContact = "Former Contact",
  OnLeave = "On Leave",
  PendingBeach = "Pending Beach",
  PendingHire = "Pending Hire",
  PendingRetire = "Pending Retire",
  PendingReturn = "Pending Return",
  PreHire = "Pre-Hire",
  Retired = "Retired",
  RescindedHire = "Rescinded Hire",
}

export const EmploymentStatusDisplay: Record<EmploymentStatus, string> = {
  [EmploymentStatus.Active]: "Active",
  [EmploymentStatus.Beach]: "Beach",
  [EmploymentStatus.FormerContact]: "Former Contact",
  [EmploymentStatus.OnLeave]: "On Leave",
  [EmploymentStatus.PendingBeach]: "Pending Beach",
  [EmploymentStatus.PendingHire]: "Pending Hire",
  [EmploymentStatus.PendingRetire]: "Pending Retire",
  [EmploymentStatus.PendingReturn]: "Pending Return",
  [EmploymentStatus.PreHire]: "Pre-Hire",
  [EmploymentStatus.Retired]: "Retired",
  [EmploymentStatus.RescindedHire]: "Rescinded Hire",
};
